module.exports = __webpack_public_path__ + "static/media/Eventy_C.02ae67bb.png";